export default "__VITE_ASSET__SbDk_$7p__"